<template>
  <div>
    <div class="bulletin-item flex">
      <div class="bulletin-item_type flex-shrink">{{ bulletinLabel }}</div>

      <el-tooltip
        effect="dark"
        :content="title"
        placement="bottom-start"
        :disabled="!showTooltip"
      >
        <div
          ref="title"
          class="bulletin-item_title text-ellipsis"
          :class="{ 'flex-2': !hideTime }"
        >
          {{ title }}
        </div>
      </el-tooltip>

      <div
        v-if="!hideTime"
        class="bulletin-item_time flex-shrink m-l-20"
        :class="{ 'flex-1': hideStatus }"
      >
        发布{{ isTimeNormDay ? '日期' : '时间' }}：<span>{{ noticeReleaseTime || '-' }}</span>
      </div>

      <div v-if="!hideStatus" class="m-l-20 flex-shrink">
        发布状态：
        <el-tag
          v-if="releaseStatusObj"
          :type="releaseStatusObj.type"
          size="small"
        >
          {{ releaseStatusObj.label || '-' }}
        </el-tag>
        <span v-else> - </span>
      </div>

      <el-button
        type="text"
        size="medium"
        class="text-primary bulletin-item_button m-l-20"
        @click="visible = true"
      >{{ buttonText }}</el-button>
    </div>

    <bulletin-dialog
      :visible.sync="visible"
      :title="title"
      :bulletin-type="bulletinLabel"
      :content="content"
    />
  </div>
</template>

<script>
import BulletinDialog from '@/components/common/Bulletins/BulletinDialog'
import DateUtils from '@/utils/date'

export default {
  name: 'BulletinItem',

  components: {
    BulletinDialog
  },

  props: {
    bulletinLabel: {
      type: String,
      default: '采购公告'
    },

    title: {
      type: String,
      default: ' - '
    },

    releaseTime: {
      type: String,
      default: ' - '
    },

    content: {
      type: String,
      default: ' - '
    },

    buttonText: {
      type: String,
      default: '查看公告'
    },

    hideTime: {
      type: Boolean,
      default: false
    },

    /**
     * 是否隐藏发布状态
     */
    hideStatus: {
      type: Boolean,
      default: true
    },

    /**
     * 发布状态
     */
    releaseStatusObj: {
      type: Object,
      default: () => null
    },

    /**
     * 发布时间 => 发布日期
     */
    isTimeNormDay: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      visible: false,
      showTooltip: false
    }
  },

  computed: {
    noticeReleaseTime() {
      return this.isTimeNormDay ? DateUtils.getNormDay(this.releaseTime) : this.releaseTime || '-'
    }
  },

  created() {
    window.addEventListener('resize', this.setToolTipShow)
  },

  mounted() {
    this.setToolTipShow()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.setToolTipShow)
  },

  methods: {
    setToolTipShow() {
      this.$nextTick(() => {
        this.showTooltip =
          this.$refs.title.offsetWidth < this.$refs.title.scrollWidth
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bulletin-item {
  padding-bottom: 14px;

  .bulletin-item_type {
    display: inline-block;
    text-align: center;
    background-color: $info-fourth-color;
    color: $second-text-color;
    padding: 2px 6px;
    margin-right: 8px;
    font-size: 12px;
  }

  .bulletin-item_title {
    @include text-bold;
  }

  .bulletin-item_time {
    span {
      color: $second-text-color;
    }
  }

  .bulletin-item_button {
    &.el-button--medium {
      padding: 0px;
    }
  }

  & + .bulletin-item {
    border-top: 1px solid $dividing-color;
    padding-top: 14px;
  }
}
</style>
